/**
 * Resolución compartida de destinos "legacy" del menú de usuario.
 *
 * Mientras un microfrontend no esté habilitado en un ambiente, ese ambiente define la variable
 * `VITE_LEGACY_<ÍTEM>_URL` (build-time) con la URL absoluta del PHP legacy y el ítem navega ahí.
 * Si la variable no está definida, si el pipeline entrega el macro sin expandir
 * ("$(VITE_LEGACY_<ÍTEM>_URL)") o si el valor no es una URL absoluta, se devuelve la ruta interna
 * del shell que monta el microfrontend.
 *
 * El resultado se resuelve con `isInternalMenuUrl` para decidir navigate() vs window.location.
 *
 * @param {string|undefined|null} envValue Valor crudo de la variable de entorno del ambiente.
 * @param {string} fallbackRoute Ruta interna del shell a usar cuando no hay URL legacy válida.
 * @returns {string} URL absoluta del PHP legacy, o la ruta interna.
 */
const URL_ABSOLUTA = /^https?:\/\//i

export function resolveLegacyMenuUrl(envValue, fallbackRoute) {
  const legacyUrl = (envValue || '').trim()

  return URL_ABSOLUTA.test(legacyUrl) ? legacyUrl : fallbackRoute
}
